// React
import React from 'react';

// Components
import Wrapper from '../../detail/Wrapper/Wrapper';

// Contexts
import { DetailContext } from '../../../contexts/detail';

// Hooks
import useDetail from '../../../hooks/useDetail';

// Third party
import { useParams } from 'react-router-dom';

// Data types
import {
  discountIncentiveCore,
  discountIncentiveDetail
} from '../../../data-types/discountIncentive';

// This component
export default function DiscountIncentiveDetail() {
  const { itemId } = useParams();
  const isNewItem = itemId === 'new';

  // Data types
  const { endpoint, getDetailId } = discountIncentiveCore();
  const { baseUrl, getInputs } = discountIncentiveDetail();

  // Detail
  const { cultures, saveCulturesDataSource, saveCultures } = useDetail();

  // JSX
  return (
    <DetailContext.Provider
      value={{
        typeOfData: 'data-type',
        title: 'Discount/Incentive',
        // Static
        itemId,
        isNewItem,
        endpoint,
        baseUrl,
        getDetailId,
        getInputs,
        // Dynamic
        cultures,
        saveCulturesDataSource,
        saveCultures
      }}>
      <Wrapper />
    </DetailContext.Provider>
  );
}
